var map = {
	"./interview-hero-img-2.webp": 3643,
	"./interview-laptop-any-job.webp": 3648,
	"./interview-laptop-compiler.webp": 3649,
	"./interview-laptop-hr.webp": 3646,
	"./interview-laptop-result-cut.webp": 3650,
	"./interview-laptop-result.webp": 3755,
	"./interview-laptop-technical.webp": 3647,
	"./interview-laptop-web.webp": 3756,
	"./interview-laptop.webp": 3437,
	"./interview-techs-2.webp": 3757,
	"./techs-icons/ds-is-icon-python-scroll.webp": 3651,
	"./techs-icons/ds-is-icon-r-scroll.webp": 3652,
	"./techs-icons/ds-is-icon-sql-scroll.webp": 3653,
	"./techs-icons/python-hero.webp": 3644,
	"./techs-icons/python-talk-is-cheap.webp": 3758,
	"./techs-icons/r-hero.webp": 3645,
	"./techs-icons/r-talk-is-cheap.webp": 3759,
	"./techs-icons/slqlite-talk-is-cheap.webp": 3760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5080;